import { render, staticRenderFns } from "./DisciplinaryIndex.vue?vue&type=template&id=34ae7e8c"
import script from "./DisciplinaryIndex.vue?vue&type=script&lang=js"
export * from "./DisciplinaryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports